import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import customerReducer from "../features/cutomers/customerSlice";
import settingReducer from "../features/setting/settingSlice";
import subscriptionReducer from "../features/subscription/subscriptionSlice";
import diamondPassUserReducer from "../features/cutomers/diamondPassUserSlice";
import normalUserReducer from "../features/cutomers/normalUserSlice";
import notificationReducer from "../features/notification/notificationSlice";
import notifictionLogReducer from '../features/notificationLog/notificationLogSlice';
import paymentLogReducer from '../features/paymentLog/paymentLogSlice';
import reportUserReducer from "../features/reportUser/reportUserSlice";
import pageReducer from '../features/page/pageSlice';
import userSubscriptionReducer from '../features/userSubscription/userSubscriptionSlice';
import userPaymentReducer from '../features/userPayment/userPaymentSlice';
import jackpotReducer from "../features/jackpot/jackpotSlice";
import priceReducer from "../features/price/priceSlice";
import redemCodeReducer from "../features/redem-code/redemCodeSlice";
import holeOutPriceReducer from "../features/hole-out-price/holeOutPriceSlice";
import challengeReducer from "../features/challenge/challengeSlice";
import holeOutRuleReducer from "../features/hole-out-rule/holeOutRuleSlice";
import holeInOneRuleReducer from "../features/hole-in-one-rule/holeInOneRuleSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    customer: customerReducer,
    setting: settingReducer,
    subscription: subscriptionReducer,
    reportUser: reportUserReducer,
    diamondPassUser: diamondPassUserReducer,
    mormalUsers: normalUserReducer,
    notification: notificationReducer,
    notificationLog: notifictionLogReducer,
    page: pageReducer,
    paymentLogs: paymentLogReducer,
    userSubscriptions: userSubscriptionReducer,
    userPayments: userPaymentReducer,
    jackpot: jackpotReducer,
    price: priceReducer,
    redemCode: redemCodeReducer,
    holeOutPrice: holeOutPriceReducer,
    challenge: challengeReducer,
    holeOutRule: holeOutRuleReducer,
    holeInOneRule: holeInOneRuleReducer,
  },
});
